module.exports = __webpack_public_path__ + "img/4_x16.1c42f40e.png";